import { useMutation, useMutationState, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export function useClientSubscriptionUpdate() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: ['client-subscription-update'],
        mutationFn: async (data) => {
            const body = new FormData()
            data.id && body.append(
                'clientId',
                data.id,
            )
            data.clientSubscription && body.append(
                'clientSubscription',
                data.clientSubscription,
            )

            return axios({
                url: [
                    process.env.REACT_APP_API_URL,
                    '/client-subscription-update',
                ].join(''),
                method: 'POST',
                withCredentials: true,
                data: body,
            }).then(response => {
                return response?.data ?? {}
            }).catch(error => {
                if (error?.response?.status === 401) {
                    queryClient.invalidateQueries({
                        queryKey: ['session-lookup'],
                    })
                }

                throw error?.response?.data ?? error
            })
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [
                    'all-client-summaries-lookup',
                ],
            })
        },
    })
}

export function useClientSubscriptionUpdateState() {
    const states = useMutationState({
        filters: {
            mutationKey: ['client-subscription-update']
        },
        select: (mutation) => Object.assign(mutation.state, {
            isIdle: mutation.state.status === 'idle',
            isPending: mutation.state.status === 'pending',
            isSuccess: mutation.state.status === 'success',
            isError: mutation.state.status === 'error',
            isDone: mutation.state.status === 'success' ||
                mutation.state.status === 'error'
        }),
    })

    return states[states.length - 1] ?? {}
}
